export default __webpack_public_path__ + "static/media/cat.3a22b309.gif";